import posthog from 'posthog-js'
import { env } from './lib/env-client'

posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
    cookieless_mode: 'on_reject',
    api_host: env.NEXT_PUBLIC_POSTHOG_HOST,
    defaults: '2025-05-24',
})
